<section #section style="pointer-events: none" id="landing" intersectionObserve intersectionRef="section"></section>

@if (isEditEnabled() === true) {
  <button (click)="openEditor()" class="movie-site_edit-button">
    <fa-icon [icon]="faPen" />
  </button>
}

@if (movie()) {
  <movie-site_top-menu [navActions]="topMenuActions()" [movie]="movie()" [appendSidemenuTo]="element" />

  <div
    #brandedMovie
    class="branded-movie"
    [class.landing-fill-screen]="landingFillScreen()"
    [ngStyle]="brandedMovieStyle()"
  >
    <movie-site-landing
      [movie]="movie()!"
      [navActions]="landingActions()"
      intersectionObserve
      intersectionRef="section"
      intersectionRef="menu"
    />

    <!-- Show in mobile devices -->
    <ng-template #filmInteractionComponentMobile />

    <div class="branded-movie-awareness--body">
      <div class="branded-movie--auxiliar-menu" [class.visible]="auxiliarMenuVisible()">
        <a class="branded-movie-awareness--logo--wrapper" (click)="goToSection('landing')" *ngIf="!hideLogoTitle">
          @if (movie()?.logoUrl) {
            <div class="branded-movie-awareness--logo--wrapper-support">
              <!-- <img
                class="branded-movie-awareness--movie--logo"
                [ngSrc]="movie()!.logoUrl!"
                sizes="(max-width:530px) 90vw, (max-width:1000px) 50vw, 30vw"
                height="150"
                width="450"
                style="height: auto; max-width: 90vw"
                priority="true"
                [alt]="'video thumbnail image of ' + movie()?.title"
              /> -->
              @if (!hideReleaseMessage) {
                <p class="branded-movie-awareness--movie--releaseMessage">
                  {{ movie()?.releaseMessage || 'release Message' }}
                </p>
              }
            </div>
          }
        </a>

        <div class="branded-movie-awareness--menu movie-site-auxiliar-menu">
          <movie-site-landing-menu [navActions]="auxiliarActions()" class="container-bounds" />
        </div>
      </div>

      <section
        #section
        #storyline
        id="storyline"
        class="branded-movie-awareness--storyline"
        [ngClass]="sectionStorylineVisibleClass()"
        intersectionObserve
        intersectionRef="section"
      >
        <div class="branded-movie-awareness--storyline--wrapper">
          <div
            class="branded-movie-awareness--storyline--portrait"
            intersectionObserve
            intersectionAnimation="slide-left"
            intesetionAnimationMobile="slide-up"
            intersectionAnimationOnce="false"
          >
            <img
              [ngSrc]="movie()!.portraitPhotoUrl!"
              width="360"
              height="540"
              priority="true"
              [alt]="movie()!.title! + ' portrait'"
            />
          </div>
          @if (movie()?.socialNetworks) {
            <!-- [class.notBrandcolorRedeable]="!isBrandColorReadable()" -->
            <div class="branded-movie-awareness--storyline--social-links">
              <h4 i18n="@@public.footer.social.link" [attr.data-translate]="'public.footer.social.link'">Follow</h4>
              <ush-social-links [socialNetworks]="movie()?.socialNetworks || []" />
            </div>
          }
          <div
            class="branded-movie-awareness--storyline--content"
            [style.--branded-movie-awareness--storyline--content__background]="synopsisConfiguration().backgroundColor"
            intersectionObserve
            intersectionAnimation="slide-right"
            intersectionRef="no-threshold"
            intersectionAnimationOnce="false"
          >
            <div class="branded-movie-awareness--storyline--content--wrapper">
              <h2
                class="branded-movie-awareness--storyline--content--title"
                [attr.data-translate]="synopsisHeader().key"
              >
                {{ synopsisHeader().text }}
              </h2>
              <div
                #descriptionContainer
                class="branded-movie-awareness--storyline--content--description"
                [innerHTML]="movie()?.description || '' | removeColorsHTML: 'moviesite' | safe: 'html'"
                [ngStyle]="{
                  '--movie-site-synopsis-body-color': synopsisConfiguration().bodyTextColor,
                  '--movie-site-synopsis-text-align': synopsisConfiguration().textAlign,
                  '--movie-site-synopsis-text-align-sm': synopsisConfiguration().textAlignSM
                }"
              ></div>
              @if (creditsPlacement() === 'synopsis') {
                <div class="branded-movie-awareness--storyline--content--credits">
                  <ush-movie-credits [movie]="movie()!" />
                </div>
              }
            </div>
          </div>
        </div>
      </section>
      <section
        #section
        id="metadata"
        class="branded-movie-awareness--metadata"
        intersectionObserve
        intersectionRef="section"
      >
        <div class="branded-movie-awareness--metadata--wrapper">
          <div
            class="branded-movie-awareness--metadata--content"
            intersectionObserve
            intersectionAnimation="slide-left"
            intesetionAnimationMobile="slide-left"
            intersectionAnimationOnce="false"
          >
            <div class="branded-movie-awareness--metadata--content--wrapper">
              <div class="branded-movie-awareness--metadata--content--info">
                @if (movie(); as currentMovie) {
                  @if (creditsPlacement() === 'more-info') {
                    <div
                      class="header-msg title branded-movie-awareness--metadata--content--info-title"
                      i18n="@@movie.menu.moreInformation"
                      i18n-attr="@@movie.menu.moreInformation"
                      data-translate="movie.menu.moreInformation"
                    >
                      More Information
                    </div>
                    <div class="branded-movie-awareness--metadata--content--credits">
                      <ush-movie-credits [movie]="currentMovie" />
                    </div>
                  }
                  <ush-movie-more-information
                    [movie]="currentMovie"
                    [showPortrait]="false"
                    [hideTitle]="creditsPlacement() === 'more-info'"
                    [disableImdb]="disableImdb()"
                    [disableTmdb]="disableTmdb()"
                  />
                }
              </div>
            </div>
          </div>

          <div
            class="branded-movie-awareness--metadata--portrait"
            intersectionObserve
            intersectionAnimation="slide-right"
            intesetionAnimationMobile="slide-up"
            intersectionAnimationOnce="false"
          >
            <div class="branded-movie-awareness--metadata--portrait--wrapper">
              <img
                [ngSrc]="movie()!.portraitPhotoUrl!"
                width="360"
                height="540"
                priority="true"
                [alt]="movie()!.title! + ' portrait'"
              />
            </div>
          </div>

          @if (movie()?.socialNetworks) {
            <div
              class="branded-movie-awareness--metadata--social-links"
              intersectionObserve
              intersectionAnimation="none"
              intesetionAnimationMobile="slide-up"
              intersectionAnimationOnce="false"
            >
              <h4 i18n="@@public.footer.social.link" [attr.data-translate]="'public.footer.social.link'">Follow</h4>
              <ush-social-links [socialNetworks]="movie()?.socialNetworks || []" />
            </div>
          }
        </div>
      </section>

      @if (!appHasOnlyMovies && (movie()?.newsPosts?.length || 0 > 0)) {
        <section
          #section
          #news
          id="news"
          class="branded-movie-awareness--news"
          intersectionObserve
          intersectionRef="section"
        >
          <community-feature-news-carousel
            *ngIf="movie()?.newsPosts?.length"
            [news]="movie()!.newsPosts!"
            [isMovieStieConfig]="true"
          />
        </section>
      }

      @if (showCompetitionInAwareness()) {
        <section
          #section
          id="competition"
          class="branded-movie-awareness--competition"
          intersectionObserve
          intersectionRef="section"
        >
          <div class="branded-movie-awareness--competition--wrapper">
            <ush-movie-competition
              [movieFriendlyUrl]="movie()?.friendlyUrl ?? ''"
              [typeFormUrl]="movie()?.properties?.competition?.typeFormUrl ?? ''"
              [typeFormData]="movie()?.properties?.competition?.typeFormData ?? ''"
            />
          </div>
        </section>
      }

      @if (movie()?.movieImages) {
        <section
          #section
          #gallery
          id="gallery"
          class="branded-movie-awareness--gallery"
          [class.notBrandcolorRedeable]="!isBrandColorReadable()"
          intersectionObserve
          intersectionRef="section"
        >
          <div class="branded-movie-awareness--gallery--wrapper">
            @defer (on viewport) {
              <feature-gallery-carousel
                [images]="movie()?.movieImages || []"
                [imageOrientation]="'landscape'"
                [slidesPerView]="gallerySlidesPerView()"
                [aspectRatio]="galleryAspectRatio()"
                [position]="galleryPosition()"
                [arrowTemplate]="6"
                [autoplay]="true"
                [scrollDrivenHorizontal]="horizontalGalleryScrollEnabled()"
              />
            } @placeholder {
              <div></div>
            }
          </div>
        </section>
      }

      @if (movie()?.reviews?.length) {
        <section
          #section
          id="reviews"
          class="branded-movie-awareness--reviews"
          [class.notBrandcolorRedeable]="!isBrandColorReadable()"
          intersectionObserve
          intersectionRef="section"
        >
          @defer (on viewport) {
            <ush-movie-reviews [movie]="movie()" [design]="'carousel'" />
          } @placeholder {
            <div></div>
          }
        </section>
      }

      @if (movie()?.copyrightImageUrl) {
        <section class="branded-movie-awareness--billing">
          <div class="branded-movie-awareness--billing--content">
            <img [src]="movie()!.copyrightImageUrl! | img" [alt]="'billing ' + movie()?.trTitle" />
          </div>
        </section>
      }

      <div class="branded-movie-awareness--sharing">
        <ush-movie-tell-friends [movie]="movie()!" ngSkipHydration />
      </div>

      <ng-template #filmInteractionComponentDesktop />

      <section class="footer-component">
        <footer-component />
      </section>
    </div>
  </div>
}

<!-- Show only on desktop -->
<app-go-to-top *ngIf="(isMobile$ | async) === false" containerTarget="feature-movie-awareness-page"></app-go-to-top>
